export const TABS_OPTIONS = [
  { label: 'Community details', value: 'general' },
  { label: 'Health systems', value: 'health_systems' }
]
export const TABS_OPTIONS_CP = [
  { label: 'Community details', value: 'general' },
  { label: 'Users', value: 'users' },
  { label: 'Health systems', value: 'health_systems' },
  { label: 'Banking setup', value: 'banking_setup' },
  { label: 'Bank accounts', value: 'bank_accounts' }
]
